import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import { apiClient } from "@/lib/auth";
import { TeaLogo } from "@/components/TeaLogo";
import { ProspectWelcome } from "@/components/nds/partnerWelcome/ProspectWelcome";

/** Public page the applicant opens from the texted welcome link. */
export default function ProspectWelcomePage() {
  const { token } = useParams();
  const [done, setDone] = useState(false);
  const finish = () => apiClient.post(`/prospect-welcome/public/${token}/watched`).finally(() => setDone(true));
  if (!done) return <ProspectWelcome token={token} onDone={finish} />;
  return (
    <div data-testid="rw-done" className="min-h-screen bg-[#07050d] text-white px-5 py-16">
      <div className="max-w-xl mx-auto space-y-4">
        <TeaLogo size={56} testid="rw-done-logo" />
        <CheckCircle2 className="h-10 w-10 text-emerald-300" />
        <h1 className="text-3xl sm:text-4xl font-semibold">Thanks for watching.</h1>
        <p className="text-white/70">Take your time with your decision. If you have questions about anything you saw, ask your referring agent. They'll walk you through the next steps.</p>
        <button type="button" onClick={() => setDone(false)} data-testid="rw-watch-again" className="rounded-full border border-white/15 px-5 py-2.5 text-sm hover:border-[#d4a017]/60 transition-colors">Watch again</button>
      </div>
    </div>
  );
}
